import { styled } from '@ori-ui/mui';
import { TooltipContainer as PbsTooltip } from '@ori/personal-beauty-store';

import { PBS_TOOLTIP_OFFSET } from './constants';

export const BurgerMenuToggleRoot = styled('div')({
  position: 'relative',
});

export const StyledPbsTooltip = styled(PbsTooltip)({
  position: 'absolute',
  top: `calc(100% - ${PBS_TOOLTIP_OFFSET.y}px)`,
  left: PBS_TOOLTIP_OFFSET.x,
});
